import { Card, CardContent, CardHeader, Grid2, Typography, useTheme } from "@mui/material";
import Text from "./Text";

const AppCard = ({ headerAction, spacing, footerActions, title, icon, children, height,shouldCenter }) => {
    const theme = useTheme();    
    const Icon=icon;
return  <Card style={{ height: height,marginBottom:theme.spacing(1) }}>
        <CardHeader
            sx={{height:61, borderBottom: "1px solid #ddd" }}
            action={headerAction}
            title={
                <Grid2 container style={{ display: "flex", alignItems: "center"}}>
                    <Icon fontSize="large"/>
                    <Text sx={{ pl: 1 }} variant="h2" text={title} />
                </Grid2>} />
        <CardContent sx={shouldCenter?{flexGrow:1,height:height-61,alignContent:"center",justifyItems:"center"}:null}>
            <Grid2 container>
                <Grid2 size={12}>
                    {children}
                </Grid2>
            </Grid2>
        </CardContent>
    </Card> 
}
export default AppCard;